<template>
  <div class="flex flex-col gap-1 w-[15rem]">
    <!-- Input with unit dropdown -->
    <div class="flex rounded-md overflow-hidden border border-light bg-base-light">
      <!-- Number Input -->
      <input type="number" :min="min" :step="step" v-model="modelValue" :placeholder="placeholder" :disabled="disabled"
             class="w-full px-3 py-3 text-sm bg-base-100 placeholder-base-200 focus:outline-none appearance-none"
             :class="disabled?'text-base-content/30':'text-base-content'" @change="emit('change', unit)"
      />

      <!-- Custom Inline Dropdown Trigger -->
      <div
        class="relative min-w-[4.5rem] bg-base-200 text-sm font-semibold select-none "
        :class="disabled?'text-base-content/30':'text-base-content cursor-pointer'"
        @click="disabled?null:unitOpen = true"
      >
        <div class="flex items-center justify-between px-3 h-full">
          <span>{{ displayLabel }}</span>
          <i class="bi bi-chevron-down text-base-content/60 text-xs" />
        </div>
      </div>
    </div>

    <!-- Modal Unit Selector -->
    <Teleport to="body">
      <div v-if="unitOpen" class="fixed inset-0 z-50">
        <!-- Overlay -->
        <div
          class="absolute inset-0 bg-black/30 backdrop-blur-sm"
          @click="unitOpen = false"
        ></div>

        <!-- Dialog -->
        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div
            class="bg-white border border-base-300 rounded-lg shadow max-h-[80vh] overflow-auto pointer-events-auto w-[90%] max-w-md p-4"
          >
            <div
              v-for="unitObj in units"
              :key="unitObj.unit"
              class="px-3 py-2 hover:bg-base-200 cursor-pointer"
              @click.stop="selectUnit(unitObj.unit)"
            >
              {{ unitObj.labelUnit }}
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue'

const modelValue = defineModel({type: Number, required: true})
const unit = defineModel('unit', {type: String, required: false})
const props = defineProps({
  placeholder: { type: String, default: '' },
  units: { type: Array, required: true }, // [{ unit: 'kg', labelUnit: 'Kg' }]
  min: {type: Number, default: null},
  step: {type: Number, default: null},
  disabled: {type: Boolean, default: false}
})

const emit = defineEmits(['update:unit','change'])

const unitOpen = ref(false)

function selectUnit(val) {
  unit.value = val // Update the local unit state
  unitOpen.value = false
}

const displayLabel = computed(() => {
  return props.units.find(u => u.unit === unit.value)?.labelUnit ?? unit.value
})
</script>